import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (error) {
      toast.error('Une erreur est survenue. Réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <img src="https://customer-assets.emergentagent.com/job_fad4c604-2efd-4142-a35f-93aeb2be7f74/artifacts/hzrybxar_logo2.jpg" alt="Phoenix Card Game" className="w-12 h-12 rounded-xl object-cover" />
          </Link>
          <h1 className="text-3xl font-bold text-white font-outfit">Mot de passe oublié</h1>
          <p className="text-gray-400 mt-2">
            {sent ? "Vérifiez votre boîte email" : "Entrez votre adresse email pour recevoir un lien de réinitialisation"}
          </p>
        </div>

        <div className="bg-[#121212] rounded-2xl p-8 border border-white/10">
          {sent ? (
            <div className="text-center py-4" data-testid="reset-email-sent">
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <p className="text-gray-300 mb-2">
                Si un compte existe avec l'adresse <span className="text-white font-medium">{email}</span>, vous recevrez un email avec un lien de réinitialisation.
              </p>
              <p className="text-gray-500 text-sm mt-4">Vérifiez également vos spams.</p>
              <Link to="/login">
                <Button className="mt-6 bg-fuchsia-600 hover:bg-fuchsia-500 text-white" data-testid="back-to-login-btn">
                  <ArrowLeft className="w-4 h-4 mr-2" /> Retour à la connexion
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="email" className="text-gray-300">Adresse email</Label>
                <div className="relative mt-2">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.com"
                    required
                    className="pl-10 bg-white/5 border-white/10 text-white placeholder:text-gray-500"
                    data-testid="forgot-email-input"
                  />
                </div>
              </div>

              <Button
                type="submit"
                className="w-full bg-fuchsia-600 hover:bg-fuchsia-500 text-white py-5"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
              </Button>

              <div className="text-center">
                <Link to="/login" className="text-fuchsia-400 hover:text-fuchsia-300 text-sm">
                  <ArrowLeft className="w-3 h-3 inline mr-1" /> Retour à la connexion
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
